import React from 'react';
import BooksInSeriesView from 'react/views/booksInSeries/BooksInSeriesView';
import CardContainer from './CardContainer';
import * as BooksInSeriesSelectors from 'data/BooksInSeriesSelectors';
import * as SeriesSelector from 'data/SeriesSelectors';
import { getJsonData } from 'data/DataStore';
import { getTitleUi } from '../../data/TitleInfoSelector';
import withOtsEnabled from 'react/containers/helper/withOtsEnabled';

const BooksInSeriesContainer = (props) => {
	const store = getJsonData();
	const titlesCardModel = BooksInSeriesSelectors.getBooksInSeries(store);
	const series = SeriesSelector.getSeries();
	const srcId = getTitleUi(store);

	return (
		<CardContainer
			seriesInfo={series}
			cardModel={titlesCardModel}
			component={BooksInSeriesView}
			itemsToRender={titlesCardModel.length}
			srcId={srcId}
			{...props}
		/>
	);
}

export default withOtsEnabled(BooksInSeriesContainer);



// WEBPACK FOOTER //
// ./src/react/containers/BooksInSeriesContainer.jsx